import { render } from "./ProsesMonev.vue?vue&type=template&id=13190bd5"
import script from "./ProsesMonev.vue?vue&type=script&lang=js"
export * from "./ProsesMonev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__